/**
 * Auto-generated by scripts/snapshot-courses.ts
 * Source: GET /api/dev/courses
 *
 * DO NOT EDIT — re-run the script to update:
 *   cd mobile && npx tsx scripts/snapshot-courses.ts
 *
 * Generated: 2026-04-06
 */

import type { LanguageCourse, LocaleMetadataFull } from '../../types/locale';
import type { CountryLocaleConfig } from '../../data/countryConfig';

export const seedCourses: LanguageCourse[] = [
  {
    "id": "de-es",
    "sourceBase": "de",
    "targetBase": "es",
    "defaultSourceLocale": "de-DE",
    "defaultTargetLocale": "es-419",
    "sourceVariants": [
      "de-DE",
      "de-AT",
      "de-CH"
    ],
    "targetVariants": [
      "es-ES",
      "es-419"
    ],
    "hasLessons": false
  },
  {
    "id": "es-en",
    "sourceBase": "es",
    "targetBase": "en",
    "defaultSourceLocale": "es-419",
    "defaultTargetLocale": "en-US",
    "sourceVariants": [
      "es-ES",
      "es-MX",
      "es-419"
    ],
    "targetVariants": [
      "en-US",
      "en-GB"
    ],
    "hasLessons": true
  }
];

export const seedLocales: LocaleMetadataFull[] = [
  {
    "code": "de-AT",
    "capabilities": { "tts": true, "stt": true, "pronunciation": false, "translation": true },
    "speech": {
      "azure": {
        "ttsVoice": "de-AT-IngridNeural",
        "sttLocale": "de-AT",
        "availableVoices": [
          {
            "id": "de-AT-IngridNeural",
            "label": "Ingrid (Female)"
          },
          {
            "id": "de-AT-JonasNeural",
            "label": "Jonas (Male)"
          }
        ]
      }
    },
    "native": {
      "language": "Deutsch",
      "variant": "Österreich",
      "variantHint": "Jänner, Paradeiser",
      "testPhrase": "Heute ist ein wunderschöner Tag"
    }
  },
  {
    "code": "de-CH",
    "capabilities": { "tts": true, "stt": true, "pronunciation": false, "translation": true },
    "speech": {
      "azure": {
        "ttsVoice": "de-CH-LeniNeural",
        "sttLocale": "de-CH",
        "availableVoices": [
          {
            "id": "de-CH-LeniNeural",
            "label": "Leni (Female)"
          },
          {
            "id": "de-CH-JanNeural",
            "label": "Jan (Male)"
          }
        ]
      }
    },
    "native": {
      "language": "Deutsch",
      "variant": "Schweiz",
      "variantHint": "Velo, Natel, ss statt ß",
      "testPhrase": "Es ist ein prächtiger Tag heute"
    }
  },
  {
    "code": "de-DE",
    "capabilities": { "tts": true, "stt": true, "pronunciation": true, "translation": true },
    "speech": {
      "azure": {
        "ttsVoice": "de-DE-KatjaNeural",
        "sttLocale": "de-DE",
        "availableVoices": [
          {
            "id": "de-DE-KatjaNeural",
            "label": "Katja (Female)"
          },
          {
            "id": "de-DE-ConradNeural",
            "label": "Conrad (Male)"
          },
          {
            "id": "de-DE-AmalaNeural",
            "label": "Amala (Female)"
          },
          {
            "id": "de-DE-BerndNeural",
            "label": "Bernd (Male)"
          },
          {
            "id": "de-DE-ElkeNeural",
            "label": "Elke (Female)"
          }
        ]
      }
    },
    "native": {
      "language": "Deutsch",
      "variant": "Deutschland",
      "variantHint": "Standarddeutsch",
      "testPhrase": "Das Wetter ist heute richtig toll"
    }
  },
  {
    "code": "en-GB",
    "capabilities": { "tts": true, "stt": true, "pronunciation": true, "translation": true },
    "speech": {
      "azure": {
        "ttsVoice": "en-GB-SoniaNeural",
        "sttLocale": "en-GB",
        "availableVoices": [
          {
            "id": "en-GB-SoniaNeural",
            "label": "Sonia (Female)"
          },
          {
            "id": "en-GB-RyanNeural",
            "label": "Ryan (Male)"
          },
          {
            "id": "en-GB-LibbyNeural",
            "label": "Libby (Female)"
          },
          {
            "id": "en-GB-ThomasNeural",
            "label": "Thomas (Male)"
          },
          {
            "id": "en-GB-MaisieNeural",
            "label": "Maisie (Female)"
          }
        ]
      }
    },
    "native": {
      "language": "English",
      "variant": "United Kingdom",
      "variantHint": "colour, organise",
      "testPhrase": "The weather is lovely today"
    }
  },
  {
    "code": "en-US",
    "capabilities": { "tts": true, "stt": true, "pronunciation": true, "translation": true },
    "speech": {
      "azure": {
        "ttsVoice": "en-US-JennyNeural",
        "sttLocale": "en-US",
        "availableVoices": [
          {
            "id": "en-US-JennyNeural",
            "label": "Jenny (Female)"
          },
          {
            "id": "en-US-GuyNeural",
            "label": "Guy (Male)"
          },
          {
            "id": "en-US-AriaNeural",
            "label": "Aria (Female)"
          },
          {
            "id": "en-US-DavisNeural",
            "label": "Davis (Male)"
          },
          {
            "id": "en-US-SaraNeural",
            "label": "Sara (Female)"
          }
        ]
      }
    },
    "native": {
      "language": "English",
      "variant": "United States",
      "variantHint": "color, organize",
      "testPhrase": "The weather is beautiful today"
    }
  },
  {
    "code": "es-419",
    "capabilities": { "tts": true, "stt": true, "pronunciation": true, "translation": true },
    "speech": {
      "azure": {
        "ttsVoice": "es-MX-DaliaNeural",
        "sttLocale": "es-MX",
        "availableVoices": [
          {
            "id": "es-MX-DaliaNeural",
            "label": "Dalia (Female)"
          },
          {
            "id": "es-MX-JorgeNeural",
            "label": "Jorge (Male)"
          },
          {
            "id": "es-MX-BeatrizNeural",
            "label": "Beatriz (Female)"
          },
          {
            "id": "es-MX-CandelaNeural",
            "label": "Candela (Female)"
          },
          {
            "id": "es-MX-CecilioNeural",
            "label": "Cecilio (Male)"
          }
        ]
      }
    },
    "native": {
      "language": "Español",
      "variant": "Latinoamérica",
      "variantHint": "tú/ustedes",
      "testPhrase": "Hoy el día está muy lindo"
    }
  },
  {
    "code": "es-ES",
    "capabilities": { "tts": true, "stt": true, "pronunciation": true, "translation": true },
    "speech": {
      "azure": {
        "ttsVoice": "es-ES-ElviraNeural",
        "sttLocale": "es-ES",
        "availableVoices": [
          {
            "id": "es-ES-ElviraNeural",
            "label": "Elvira (Female)"
          },
          {
            "id": "es-ES-AlvaroNeural",
            "label": "Álvaro (Male)"
          },
          {
            "id": "es-ES-AbrilNeural",
            "label": "Abril (Female)"
          },
          {
            "id": "es-ES-ArnauNeural",
            "label": "Arnau (Male)"
          },
          {
            "id": "es-ES-XimenaNeural",
            "label": "Ximena (Female)"
          }
        ]
      }
    },
    "native": {
      "language": "Español",
      "variant": "España",
      "variantHint": "tú/vosotros",
      "testPhrase": "Hoy hace un tiempo estupendo"
    }
  },
  {
    "code": "es-MX",
    "capabilities": { "tts": true, "stt": true, "pronunciation": true, "translation": true },
    "speech": {
      "azure": {
        "ttsVoice": "es-MX-DaliaNeural",
        "sttLocale": "es-MX",
        "availableVoices": [
          {
            "id": "es-MX-DaliaNeural",
            "label": "Dalia (Female)"
          },
          {
            "id": "es-MX-JorgeNeural",
            "label": "Jorge (Male)"
          },
          {
            "id": "es-MX-BeatrizNeural",
            "label": "Beatriz (Female)"
          },
          {
            "id": "es-MX-CandelaNeural",
            "label": "Candela (Female)"
          },
          {
            "id": "es-MX-CecilioNeural",
            "label": "Cecilio (Male)"
          }
        ]
      }
    },
    "native": {
      "language": "Español",
      "variant": "México",
      "variantHint": "tú/ustedes",
      "testPhrase": "Hoy el día está muy bonito"
    }
  }
];

export const seedCountries: CountryLocaleConfig[] = [
  {
    "code": "AR",
    "emoji": "🇦🇷",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "AT",
    "emoji": "🇦🇹",
    "locales": [
      "de-AT"
    ]
  },
  {
    "code": "BE",
    "emoji": "🇧🇪",
    "locales": [
      "de-DE",
      "fr-BE",
      "nl-BE"
    ]
  },
  {
    "code": "BO",
    "emoji": "🇧🇴",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "CA",
    "emoji": "🇨🇦",
    "locales": [
      "en-CA",
      "fr-CA"
    ]
  },
  {
    "code": "CH",
    "emoji": "🇨🇭",
    "locales": [
      "de-CH",
      "de-DE",
      "fr-CH"
    ]
  },
  {
    "code": "CL",
    "emoji": "🇨🇱",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "CO",
    "emoji": "🇨🇴",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "CR",
    "emoji": "🇨🇷",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "CU",
    "emoji": "🇨🇺",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "DE",
    "emoji": "🇩🇪",
    "locales": [
      "de-DE"
    ]
  },
  {
    "code": "DO",
    "emoji": "🇩🇴",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "EC",
    "emoji": "🇪🇨",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "ES",
    "emoji": "🇪🇸",
    "locales": [
      "es-ES"
    ]
  },
  {
    "code": "GQ",
    "emoji": "🇬🇶",
    "locales": [
      "es-ES"
    ]
  },
  {
    "code": "GT",
    "emoji": "🇬🇹",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "HN",
    "emoji": "🇭🇳",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "LI",
    "emoji": "🇱🇮",
    "locales": [
      "de-AT"
    ]
  },
  {
    "code": "LU",
    "emoji": "🇱🇺",
    "locales": [
      "de-DE",
      "fr-FR"
    ]
  },
  {
    "code": "MX",
    "emoji": "🇲🇽",
    "locales": [
      "es-MX"
    ]
  },
  {
    "code": "NI",
    "emoji": "🇳🇮",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "NZ",
    "emoji": "🇳🇿",
    "locales": [
      "en-NZ"
    ]
  },
  {
    "code": "PA",
    "emoji": "🇵🇦",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "PE",
    "emoji": "🇵🇪",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "PR",
    "emoji": "🇵🇷",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "PY",
    "emoji": "🇵🇾",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "SV",
    "emoji": "🇸🇻",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "US",
    "emoji": "🇺🇸",
    "locales": [
      "es-419",
      "es-MX"
    ]
  },
  {
    "code": "UY",
    "emoji": "🇺🇾",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "VE",
    "emoji": "🇻🇪",
    "locales": [
      "es-419"
    ]
  },
  {
    "code": "ZA",
    "emoji": "🇿🇦",
    "locales": [
      "en-ZA"
    ]
  }
];
